module.exports = __webpack_public_path__ + "static/media/ac1.9a15dd1c.jpg";